import { useEffect, useState } from 'react';
import moment from 'moment';
import swal from 'sweetalert2';
import ic_check_on from '../../../assets/images/ic_check_on.png'
import golf_cart from '../../../assets/images/golf_cart.png'
import golf_caddy from '../../../assets/images/golf_caddy.png'
import { serverDate } from '../../../assets/scripts/periodSelection';  // to get server date
import { getTeeTimeBookSheet } from "../../api/teeTimeAPI";
import BookSheetHeader from './bookSheetHeader';

// import * as helper from '../../global/helper';
import Loading from "../../global/loading";

import {
    // extractPlayersFromBookings,
    showBookPlayer,
    showBookStatus,
    showEditButton,
    showSlot
} from './bookSheetHelper';

import BookingDrawer from './bookingDrawer';
import CourseClosed from '../../golfClub/courseClosed';

const BookingSheet = (props) => {
    const [isInit, setIsInit] = useState(true);
    const [drawer, setDrawer] = useState(false);   

    //Stores TeeSheet and Cart Data -
    const [teeTimeBookSheet, setTeeTimeBookSheet] = useState([]);    
    const [masterData, setMasterData]= useState([]);      
    // const [cartStatusDetails, setCartStatusDetails] = useState({});

    //Top Bar States --
    const [selectedDate, setSelectedDate] = useState(moment(serverDate, 'YYYY-MM-DD').format('DD-MM-YYYY'));
    const [selectedTeeBox, setSelectedTeeBox] = useState(1);
    
    
    const [typeOption, setTypeOption] = useState(['Member','Guest']);
    const [type, setType] = useState(typeOption[0]);
    

    //For Datatable --
    const [bookingTable, setBookingTable]= useState(null); 

    //Holds Drawer Data -
    const [bookSheet, setBookSheet]= useState({});    
    const [isActionAllowed, setIsActionAllowed]= useState(false);    

    //#region Effects--
    
        useEffect(() => {
            props.title("Booking Sheet", "tee-sheet")    
            
            $('#txtDate').datepicker({
                format: 'dd-mm-yyyy', minDate: new Date(),
            });  

            $('#txtDate').on('change', function ({target}) {
                setSelectedDate(target.value)
            });         
        },[]) //INIT

        useEffect(() => {   
            if(selectedDate && selectedTeeBox){
                fetchTeeTimeBookSheetData(moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD'), selectedTeeBox )
            }
        },[selectedDate, selectedTeeBox])  // fetches teesheet on date and teebox change

        useEffect(() => {       
            if (!isInit) fillDataTable();        
        }, [teeTimeBookSheet]); // fills the table on teeSheet update
    //#endregion

    //#region API calls--
        const fetchTeeTimeBookSheetData = async(date, teebox = 1, from = '') => {
            try {               
                swal.fire({
                    titleText: 'Loading',
                    text: 'Just a moment while we load everything...',
                    showConfirmButton: false,
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    onOpen: () => {
                        swal.showLoading();
                    }
                });

                const response = await getTeeTimeBookSheet(date, teebox);     
                
                //  if(from == "Update") updateBookingDetails('TemplateID', response?.BookSheet[0]?.TemplateID) //@REWORK - THIS RESETS bookSheet Which already set onClik edit icon 
                isInit ? setIsInit(false) : $('#tblBookSheet').KTDatatable().destroy(); 
                setTeeTimeBookSheet({
                    BookSheet: response.BookSheet,
                    Holiday : response?.Holiday,
                    CourseClosed : response?.CourseClosed,
                    ServerDate : response?.ServerDate,
                    Type : response.Type,
                });
                                
                setMasterData(response?.TeeSheetData);
                // setCartStatusDetails(response?.CartStatus);
                
            } catch (err) {
                swal.fire({ icon : 'error', titleText : err.message })  ;
            }finally{
                swal.close();
            }
        }            

        const refetchTeeSheet =()=>{
            fetchTeeTimeBookSheetData(moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD'), selectedTeeBox)
        }

    //#endregion       

    //#region Table Functions --
        function fillDataTable() {
            swal.close();

            const check = '<img src="' + ic_check_on + '" style="height: 20px; width: 20px; float:right;"/>';
            const cart  = '<img src="' + golf_cart + '" style="height: 22px; width: 22px; float:right; margin-left:5px"/>';
            const caddy = '<img src="' + golf_caddy + '" style="height: 20px; width: 20px; float:right; margin-left:5px"/>';

            $('#lblHoliday').text(teeTimeBookSheet?.Holiday ? `Holiday : ${teeTimeBookSheet?.Holiday?.Name}` : (teeTimeBookSheet?.CourseClosed ? `CourseClosed : ${teeTimeBookSheet?.CourseClosed?.Name}` : ''));
            
            const bookingList = teeTimeBookSheet.BookSheet || [];
            
           // Enhance player info
            bookingList.forEach(booking => {
                [1, 2, 3, 4].forEach(i => {
                    let playerKey = `Player${i}`;
                    if (!booking[playerKey]) return;

                    if (booking[`${playerKey}Caddy`] === 'Y') booking[playerKey] += caddy;
                    if (booking[`${playerKey}Cart`] === 'Y') booking[playerKey] += cart;
                    if (booking[`${playerKey}IsPresent`] === 'Y') booking[playerKey] += check;
                });
            });

            const dataTable = $('#tblBookSheet').KTDatatable({
                data: { saveState: false, source: bookingList },
                layout: { scroll: true, footer: false,},
                sortable: false,
                pagination: false,
                search: { input: $('#generalSearch')},
                columns: [
                    { field: 'Slot', title: 'Slot', width: 110, template: showSlot },
                    { field: 'Status', title: 'Status', width: 70, template: showBookStatus },
                    ...[1, 2, 3, 4].map(i => ({
                        field: `Player${i}`,
                        title: `Player ${i}`,
                        width: 100,
                        template: (row) => showBookPlayer(row, i - 1)
                    })),
                    {
                        field: '', title: '', width: 50,
                        template: row => row?.Status ? showEditButton(row, teeTimeBookSheet) : ''
                    }
                ],
                rows: { autoHide: false }
            });

            $('#root .kt-grid--hor').addClass('max-width100');
            $('#tblBookSheet .kt-datatable__table').addClass('overflow-x-auto');

            Config.Core.InitPopover();
            Config.Core.GrabAndScroll('.kt-datatable__table');

            // export to excel
            const BookingTable = $('.kt-datatable__table').tableExport({
                headers: true, formats: ["xlsx", "csv"],
                filename: `${moment().format("DD-MM-YYYY")} - Tee Booking Sheet - ${type.TeeBox} Tee Box`,
            });

            setBookingTable(BookingTable);
            $('.tableexport-caption').addClass('hidden');                
            
            //click handler for drawer
            dataTable.on('click', '.btn-edit', function (e) {
                const index = $(e.currentTarget).parents('tr').index();                                    

                if (dataTable.dataSet && dataTable.dataSet.length > 0 && dataTable.dataSet[index]) {
                    const index = $(e.currentTarget).parents('tr').index();
                    const rowData = dataTable.dataSet?.[index];
                    
                    if (!rowData) return;

                    // Ensure RelatedBookings has a blank entry if none with ID: 0
                    if (!rowData.RelatedBookings.find(b => b.ID === 0)) {
                        rowData.RelatedBookings.push({ ID: 0, Comment: "", CompanyID: 0, Discount: 0 });
                    }

                    const bookSheetData = {
                        ...rowData,
                        Type: 'Member',
                        TeeBox: rowData.TeeBox || type.TeeBox,
                        Hole: rowData.Hole || "18",                     
                    };

                    setBookSheet(bookSheetData);
                    setDrawer(true);

                    const formattedDate = moment($('#txtDate').val(), 'DD/MM/YYYY').format('DD-MMM-YYYY');
                    const isDateEditable = moment(moment(teeTimeBookSheet?.ServerDate).format('DD-MMM-YYYY')).isSameOrBefore(formattedDate);
                    setIsActionAllowed(isDateEditable);
                    // if (bookSheetData?.ID) {
                    //     fetchBookingDetails(bookSheetData.TemplateID, moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD'));
                    //     if (bookSheetData.OwnerID !== 0) setGuestUserID(bookSheetData.OwnerID);
                    // }
                } 
            });
        }                
    //#endregion

    return(<>
        <div className="kt-content kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor padding-tb0" id="kt_content"  >
            <div className="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid margin-t20">
                <div className="kt-portlet">
                    <div className="kt-portlet__body padding-t30 padding-b0">
                        <div id="ControlHolder" className="kt-form kt-form--label-right padding-10" role="form">
                            <BookSheetHeader 
                                bookingTable      = {bookingTable}
                                selectedDate      = {selectedDate}
                                selectedTeeBox    = {selectedTeeBox}
                                setSelectedTeeBox = {setSelectedTeeBox}
                            />
                        </div>

                        <h5 id="lblHoliday" className="lblHoliday"></h5>                       
                
                        <div id="tblBookSheet" className="table table-bordered table-hover custom-datatable"></div>
                        
                        {drawer && (
                            <BookingDrawer
                                drawer           = {drawer}
                                setDrawer        = {setDrawer}
                                typeOption       = {typeOption}
                                masterData       = {masterData}
                                bookSheet        = {bookSheet}
                                setBookSheet     = {setBookSheet}
                                selectedDate     = {selectedDate}
                                teeTimeBookSheet = {teeTimeBookSheet}  
                                isActionAllowed  = {isActionAllowed}
                                refetchTeeSheet  = {refetchTeeSheet}                            
                            />
                        )}
                        
                    </div>
                </div>
            </div>
        </div>

    </>);
}

export default BookingSheet;